import { AxiosResponse } from 'axios';
import { apiWrapper, axiosApi } from 'utils/api';

export const apiSSODetail = async (): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse<any>> => {
    const response = await axiosApi().get<any>(`/sso/provider/one`);
    return {
      ...response,
    };
  };

  return apiWrapper<any>({
    success,
  });
};

export const apiSSOList = async (): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse<any>> => {
    const response = await axiosApi().get<any>(`/sso/provider/all`);
    return {
      ...response,
    };
  };

  return apiWrapper<any>({
    success,
  });
};

export const apiSSOEnableList = async (
  tenantId: string,
): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse<any>> => {
    const response = await axiosApi().get<any>(`/sso/provider/enabled-all`, {
      params: { tenantId },
    });
    return {
      ...response,
    };
  };

  return apiWrapper<any>({
    success,
  });
};

export const apiSSOLogin = async (
  id: string,
  tenantId: string,
): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse<any>> => {
    const response = await axiosApi().get<any>(`/sso/saml/login`, {
      params: { tenantId, id },
    });
    return {
      ...response,
    };
  };

  return apiWrapper<any>({
    success,
  });
};

export const apiSSOCreate = async (
  data: any,
): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse<any>> => {
    const response = await axiosApi().post<any>(`/sso/provider`, data);
    return {
      ...response,
    };
  };

  return apiWrapper<any>({
    success,
  });
};
